import React from 'react'
import { Modal, ModalBody, ModalFooter } from 'uiComponents/popups/modal.new'
import { MembershipPayment } from 'memberships/schema'
import { CancelButton } from 'uiComponents/buttons/cancelButton'
import { DateFormats } from 'utils'
import { formatISOString } from 'utils'
import PressAndHoldButton from 'uiComponents/buttons/pressAndHoldButton'
import Currency from 'uiComponents/money/currency'
import './refundPaymentModal.scss'

interface RefundPaymentModalProps {
    payment: MembershipPayment
    onClose: () => void
    onRefund: (payment: MembershipPayment) => void
}

const RefundPaymentModal: React.FC<RefundPaymentModalProps> = ({ payment, onClose, onRefund }) => {
    const amount = <Currency amount={payment.amount} currency={payment.currency} />
    return (
        <Modal className="refund-payment-modal" title={<>Refund {amount}?</>} onDismiss={onClose}>
            <ModalBody>
                <div>
                    You are issuing a refund for the payment of {amount} collected on{' '}
                    {formatISOString(payment.paymentDate, DateFormats.LONG_DATE)}.
                </div>
                <div>This action cannot be reverted.</div>
            </ModalBody>
            <ModalFooter>
                <CancelButton onClick={onClose}>Go back</CancelButton>
                <PressAndHoldButton
                    text="Confirm refund"
                    holdTime={3000}
                    onComplete={() => onRefund(payment)}
                    destructive
                />
            </ModalFooter>
        </Modal>
    )
}

export default RefundPaymentModal
